"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _AppSettingsProvider = require("../../app/AppSettingsProvider/AppSettingsProvider");

var getBreadcrumbsData = function getBreadcrumbsData(breadcrumbs, siteRoot, t) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map(function (b, idx) {
      return {
        '@type': 'ListItem',
        position: idx + 1,
        name: t(b.label, {
          acceptString: true
        }),
        item: "".concat(siteRoot).concat(b.href)
      };
    })
  };
};

function StructuredDataBreadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var siteRoot = (0, _AppSettingsProvider.useAppSettingsSiteRoot)();
  var t = (0, _useTranslate.default)();
  return breadcrumbs && breadcrumbs.length ? /*#__PURE__*/_react.default.createElement(_reactHelmet.default, null, /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(getBreadcrumbsData([{
    href: '/',
    label: t('globalNavigation/home')
  }].concat((0, _toConsumableArray2.default)(breadcrumbs)), siteRoot, t)))) : null;
}

process.env.NODE_ENV !== "production" ? StructuredDataBreadcrumbs.propTypes = {
  breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    }))]).isRequired
  }))
} : void 0;
StructuredDataBreadcrumbs.defaultProps = {
  breadcrumbs: undefined
};
var _default = StructuredDataBreadcrumbs;
exports.default = _default;